// Copier un texte dans le presse-papiers. Repli pour les navigateurs qui le refusent (page non sécurisée, aperçu…).
export async function copierTexte(texte: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(texte);
    return true;
  } catch { /* repli ci-dessous */ }
  try {
    const t = document.createElement('textarea');
    t.value = texte;
    t.setAttribute('readonly', '');
    t.style.position = 'fixed';
    t.style.opacity = '0';
    document.body.appendChild(t);
    t.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(t);
    return ok;
  } catch {
    return false;
  }
}
